import React from "react"
import { withTranslation } from 'react-i18next'
import { Button, Col, Container, Form, Row } from "react-bootstrap"
import { compose, getAllModalFunctions, getDataFromModals } from "../../../utils"
import { withTLService } from "../../hoc"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import BaseModal from "../base-modal"
import JsonEditorModal from "../modal-add-edit-task-type/json-editor"

class ModalAddEditTaskCron extends BaseModal {
    state = {
        jsonModalOpen: false
    }

    handleSave = (value) => {
        const { index } = this.props
        this.props.modalUpdateData(index, { settings: value })
        this.setState({ jsonModalOpen: false })
    }

    render() {
        const { index } = this.props
        const data = getDataFromModals(this.props, index)
        const { name, cron, settings } = data
        const { t: translate } = this.props

        return (
            <Container>
                <Row>
                    <Col md={6}>
                        <Form.Group controlId="taskCronName">
                            <Form.Label>{translate('Name')}</Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                defaultValue={name}
                                onChange={e => this.handleChange(e)}
                                placeholder={translate('Enter name')}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Form.Group controlId="taskCronExpression">
                            <Form.Label>{translate('Cron')}</Form.Label>
                            <Form.Control
                                type="text"
                                name="cron"
                                defaultValue={cron}
                                onChange={e => this.handleChange(e)}
                                placeholder={translate('Enter cron expression')}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="align-items-center">
                    <Col md={8}>
                        <Form.Group controlId="taskCronSettings">
                            <Form.Label>{translate('Settings')}</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={6}
                                name="settings"
                                type="text"
                                onClick={() => this.setState({ jsonModalOpen: true })}
                                value={typeof settings === "object" ? JSON.stringify(settings) : settings || ''}
                                readOnly
                                placeholder={translate('Enter JSON settings (optional)')}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Button
                            className="fas fa-edit"
                            onClick={() => this.setState({ jsonModalOpen: true })} />
                    </Col>
                </Row>
                <JsonEditorModal
                    open={this.state.jsonModalOpen}
                    onClose={() => this.setState({ jsonModalOpen: false })}
                    value={settings}
                    onSave={this.handleSave}
                    title={translate('Cron Settings')}
                />
            </Container>
        )
    }
}

const mapStateToProps = ({ userData, modalData, openData, adminData }) => {
    return { userData, openData, modalData, adminData }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        ...getAllModalFunctions(),
    }, dispatch)
}

export default compose(
    withTranslation(),
    withTLService(),
    connect(mapStateToProps, mapDispatchToProps)
)(ModalAddEditTaskCron)
